import * as React from 'react';

import DemoBlockedModal from './demoBlockedModal';
import { useDemoAccountContextProvider } from '../../contexts/DemoAccountContextProvider';
import { DropdownInput } from '../../../Shared/index';

type DropdownInputProps = React.ComponentProps<typeof DropdownInput>;

const DemoGuardedDropdownInput: React.FC<DropdownInputProps> = ({ handleChange, ...rest }) => {
  const { isDemo } = useDemoAccountContextProvider();
  const [showModal, setShowModal] = React.useState(false);

  const handleCloseModal = () => setShowModal(false);

  const guardedHandleChange = (selection: any) => {
    if (isDemo) {
      setShowModal(true);
    } else {
      handleChange?.(selection);
    }
  };

  return (
    <React.Fragment>
      <DropdownInput {...rest} handleChange={guardedHandleChange} />
      {showModal && <DemoBlockedModal onClose={handleCloseModal} />}
    </React.Fragment>
  );
};

export default DemoGuardedDropdownInput;
